import {btoa} from 'abab'
import {graphql, useLazyLoadQuery} from 'react-relay/hooks'
import {useParams} from 'react-router-dom'
import {Box, Stack, Text} from '@chakra-ui/react'

import {GameListUserProfileIndexQuery} from './__generated__/GameListUserProfileIndexQuery.graphql'

import {Heading} from 'components/Heading'
import {GameFeed} from 'components/GameFeed'
import {GameListItemCompact} from 'components/GameListItem'

export function GameList() {
  const {userId} = useParams()
  const {user} = useLazyLoadQuery<GameListUserProfileIndexQuery>(
    graphql`
      query GameListUserProfileIndexQuery($userId: ID!) {
        user(id: $userId) {
          isViewer
          followerPrivacy
          pastGames: games(
            first: 15
            orderBy: {direction: DESC, field: START_TIME}
            times: [PAST]
          ) {
            pageInfo {
              hasNextPage
              total
            }
            edges {
              node {
                ...GameFeed_games
              }
            }
          }
          upcomingGames: games(
            first: 15
            orderBy: {direction: DESC, field: START_TIME}
            times: [UPCOMING]
          ) {
            pageInfo {
              total
            }
            edges {
              node {
                ...GameListItemCompact_game
                id
              }
            }
          }
        }
      }
    `,
    {
      userId: btoa(`User:${userId}`),
    }
  )

  function showGames() {
    if (!user.followerPrivacy || user.isViewer) {
      return (
        <Box>
          <Heading>Upcoming Games</Heading>
          {user.followerPrivacy && user.isViewer ? (
            <Text>Your upcoming games are hidden from public view</Text>
          ) : null}
          {user.upcomingGames.pageInfo.total >= 1 ? (
            <Stack mt={4} spacing={4}>
              {user.upcomingGames.edges.map((edge) => (
                <GameListItemCompact game={edge.node} key={edge.node.id} />
              ))}
            </Stack>
          ) : (
            <Box mt={4}>No upcoming games</Box>
          )}
        </Box>
      )
    } else {
      return
    }
  }

  return (
    <Box>
      {showGames()}
      <Heading mb={4} mt={8}>
        Past Games
      </Heading>
      <GameFeed
        games={user.pastGames.edges.map(({node}) => node)}
        gameType="full"
      />
    </Box>
  )
}
